module.exports = __webpack_public_path__ + "img/SC.14eab3bd.svg";